//GET
export const GET_ALL_GAMES = "GET_ALL_GAMES"
export const GET_ALL_GAMES_FAIL = "GET_ALL_GAMES_FAIL"